import { PlanStack } from '@zapier/design-system-revenue/src/types';
import { BillingInterval } from '@zapier/design-system-revenue/src/graphql-types';
import { planIds } from './planIds';

const commonProps = {
  __typename: 'PlanV2' as 'PlanV2',
  allowCompanies: false,
  hasAutoReplay: true,
  hasPaths: true,
  hasMultiStepZaps: true,
  hasPremiumApps: true,
  hasTeams: true,
  isInPlanGroup: true,
  description: 'Bring your team together to collaborate on automation.',
  features: [
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Multi-step Zaps',
      tooltip:
        'Multi-Step Zaps let a single Trigger (e.g. new email lead) perform as many Actions (e.g. add to my CRM) as you want.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: '/apps?filter=premium',
      name: 'Unlimited Premium Apps',
      tooltip:
        'Premium apps are select apps that are exclusively available to users on a paid plans.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Filters',
      tooltip:
        'Filters tell your Zaps to run only if your data matches certain criteria.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Formatters',
      tooltip:
        'Formatters let you tweak numbers, dates, and text in over a dozen ways to get it in the format you need.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Custom Integrations',
      tooltip:
        'Build powerful, custom integrations that connect any app with Webhooks by Zapier.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Custom Logic - Paths',
      tooltip:
        'Build advanced workflows using branching logic to run different actions based on conditions you decide.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Auto Replay',
      tooltip:
        'Intelligently retries any Task failures due to temporary errors or downtime for you.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Unlimited Users',
      tooltip: 'Add unlimited users to your account at no additional cost.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Folder Permissions',
      tooltip: 'Control who can edit shared Zaps and access shared folders.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Premier Support',
      tooltip:
        'Get faster, prioritized responses from our dedicated Premier Support team.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Shared App Connections',
      tooltip:
        'Connect your team’s favorite tools, like Trello, Dropbox, or Typeform, so everyone can use them in their workflows without needing to share passwords and API keys.',
    },
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      href: null,
      name: 'Shared Workspace',
      tooltip: 'Share access to your Zaps with your team.',
    },
  ],
  type: 'Team',
  zaps: -1,
  zapsRunInterval: 1,
  hasMeteredBilling: false,
  tiers: [
    { numTasks: 50000, pricePerTask: 0, __typename: 'PlanTier' as 'PlanTier' },
    {
      numTasks: 50000,
      pricePerTask: 0.5,
      __typename: 'PlanTier' as 'PlanTier',
    },
    {
      numTasks: 250000,
      pricePerTask: 0.25,
      __typename: 'PlanTier' as 'PlanTier',
    },
    {
      numTasks: 500000,
      pricePerTask: 0.15,
      __typename: 'PlanTier' as 'PlanTier',
    },
    { numTasks: -1, pricePerTask: 0.1, __typename: 'PlanTier' as 'PlanTier' },
  ],
};

export const teamPlanStackMock: PlanStack = {
  __typename: 'PlanTaskGrouping',
  id: 'Team',
  plans: [
    {
      ...commonProps,
      amount: 358800,
      interval: BillingInterval.year,
      id: planIds.TEAM_50000_YEARLY,
      name: 'Team (50,000 Tasks)',
      tasks: 50000,
    },
    {
      ...commonProps,
      amount: 37375,
      interval: BillingInterval.month,
      id: planIds.TEAM_50000_MONTHLY,
      name: 'Team (50,000 Tasks)',
      tasks: 50000,
    },
    {
      ...commonProps,
      amount: 598800,
      interval: BillingInterval.year,
      id: planIds.TEAM_100000_YEARLY,
      name: 'Team (100,000 Tasks)',
      tasks: 100000,
    },
    {
      ...commonProps,
      amount: 62375,
      interval: BillingInterval.month,
      id: planIds.TEAM_100000_MONTHLY,
      name: 'Team (100,000 Tasks)',
      tasks: 100000,
    },
  ],
  planType: 'Team',
};
